import { render, staticRenderFns } from "./GenerationHistoryDetailCardDesignBoard.vue?vue&type=template&id=14632f71"
import script from "./GenerationHistoryDetailCardDesignBoard.vue?vue&type=script&lang=js"
export * from "./GenerationHistoryDetailCardDesignBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports